module.exports = __webpack_public_path__ + "img/zhilian_4.81979935.png";